import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {
  [types.SET_CARD_FOR_NEW_CLASS](state, card) {
    Vue.set(state, 'newClassCard', card);
  },

  [types.SET_PAGE_LIST_FOR_NEW_CLASS](state, pageList) {
    Vue.set(state, 'newClassPages', pageList);
  },

  [types.SET_CURRENT_PAGE_FOR_NEW_CLASS](state, page) {
    Vue.set(state, 'newClassCurrentPage', page);
  },

  [types.SET_PAGINATION_FOR_NEW_CLASS](state, pagination) {
    Vue.set(state, 'newClassPagination', pagination);
  },

  [types.SET_QUIZ_VALUE_FOR_NEW_CLASS](state, { quizId, value }) {
    Vue.set(state, 'newClassEnteredValue', value);
    Vue.set(state.newClassPreEnteredValues, quizId, value);
  },

  [types.RESET_ENTERED_VALUE_FOR_NEW_CLASS](state) {
    Vue.set(state, 'newClassEnteredValue', '');
  },

  [types.SET_QUIZ_OPTION_FOR_NEW_CLASS](state, { quizId, option }) {
    Vue.set(state, 'newClassSelectedOptions', option);
    Vue.set(state.newClassPreSelectedOption, quizId, option);
  },

  [types.SET_PAGE_RESULT_FOR_NEW_CLASS](state, { pageId, pageIndex, pageType, essay, multipleChoiceOption, maxPoints, textEntry, isCorrect, duration, correctOptions }) {
    Vue.set(state.newClassPagesResult, pageId, { pageId, pageIndex, pageType, essay, multipleChoiceOption, maxPoints, textEntry, isCorrect, duration, correctOptions });
  },

  [types.SET_ALL_PAGE_RESULT_FOR_NEW_CLASS](state, results) {
    Vue.set(state, 'newClassPagesResult', results);
  },

  [types.RESET_SELECT_OPTIONS_FOR_NEW_CLASS](state) {
    Vue.set(state, 'newClassSelectedOptions', {});
  },

  [types.SAVE_GRADING_STATUS_FOR_NEW_CLASS](state, isGraded) {
    Vue.set(state, 'newClassGradingStatus', isGraded);
  },
};

export default mutations;
